// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"495":"76397979","592":"53059957","696":"a46a742e"}[chunkId] + ".chunk.css";
};